import React from 'react';
import Form from '../form/Form';
import { useHistory } from 'react-router-dom';
import { modal } from '../modal/ModalEmitter';
import ApiService from '../../services/ApiService';

const getLayout = (presets = {}) => {
  const assignee = {
    name: 'assignedTo',
    label: 'Assigned To',
    // readOnlyOnInit: true,
    validation: {
      type: 'db',
      modelName: 'Salesperson',
      format: 'user',
    },
    control: 'dbselect',
  };

  const deal = {
    name: 'dealId',
    label: 'Add To Existing Deal',
    validation: {
      type: 'db',
      modelName: 'EQS2',
      emptyOption: { label: 'New Deal', value: '' },
    },
    control: 'dbselect',
    readOnly: true,
  };

  const unit = {
    name: 'units',
    label: 'Unit',
    validation: {
      page: 'AVI2',
      type: 'vehiclesale',
      filter: {
        // Only Available should be selected
        Status: ['Available'],
      },
    },
    required: true,
    control: 'Tags',
  };

  const multiunit = {
    name: 'units',
    label: 'Select Units',
    control: 'MultiUnitSelection',
  };

  if (presets.assignee) {
    assignee.data = presets.assignee;
    // assignee.readOnlyOnInit = true; // TODO dont set for manager
  }

  if (presets.deal) {
    deal.data = presets.deal;
    deal.readOnly = true;
    deal.hidden = false;
  }

  return [
    deal,
    assignee,
    {
      col: 6,
      noEmptyOption: true,
      name: 'copyBasis',
      label: 'Copy Basis',
      options: [
        { label: 'Copy Retail', value: 'CR' },
        { label: 'Flat Retail', value: 'FR' },
        { label: 'Gross Profit %', value: 'GPP' },
      ],
    },
    {
      col: 6,
      name: 'copyRetailPrice',
      label: 'Retail Value',
      data: presets.retailPrice,
      dependencies: {
        and: [{ '==': ['copyBasis', 'CR'] }],
        action: 'show',
      },
      displayOnly: true,
      style: 'line-item',
      type: 'currency',
    },
    {
      col: 6,
      label: 'Retail Value',
      name: 'flatRetailValue',
      data: presets.retailPrice,
      dependencies: {
        and: [{ '==': ['copyBasis', 'FR'] }],
        action: 'show',
      },
      type: 'currency',
    },
    {
      col: 6,
      label: 'Gross Profit Percent',
      name: 'grossProfitPercent',
      data: presets.grossProfitPercent,
      dependencies: {
        and: [{ '==': ['copyBasis', 'GPP'] }],
        action: 'show',
      },
      type: 'percent',
    },
    // unit,
    multiunit,
  ];
};

const CreateSimilarQuote = ({ quote, submitCallback }) => {
  const history = useHistory();

  const jumpToQuote = (quoteId, dealId) => {
    history.push(`/db/EQS2/${dealId}/edit?oq=${quoteId}`);
    modal.close();
  };

  const handleSubmit = payload => {
    return ApiService.post(`/crm/quote/${quote.id}/create-similar`, { ...payload }).then(response => {
      const created = response.data;
      const message = (
        <div>
          The following quotes were created:{' '}
          {created.map((id, index) => {
            return (
              <span key={id}>
                <a href="#" onClick={() => jumpToQuote(id, quote.dealId)}>
                  {id}
                </a>
                {created.length !== index + 1 && <>, </>}
              </span>
            );
          })}
        </div>
      );

      modal.close();
      modal.info({
        title: 'Quotes Created',
        headerClass: '',
        size: 'sm',
        message,
      });

      if (submitCallback) {
        submitCallback();
      }
    });
  };

  return (
    <div className="copy-similar-quote">
      <div className="info-sect" style={{ marginLeft: '15px', marginRight: '15px' }}>
        <i className="fas fa-info-circle" />
        <div>
          The form will create quotes for the specified units below using the values saved for{' '}
          <strong>Q{quote.id}</strong>.
        </div>
      </div>
      <Form
        layout={getLayout({
          deal: quote.dealId,
          vehicle: quote.vehicleId,
          assignee: quote.assignedTo,
          retailPrice: quote.data.retailPrice,
          grossProfitPercent: quote.data.salesPriceGrossProfitPercent,
        })}
        trackDirty={false}
        onCancel={() => modal.close()}
        submit={handleSubmit}
        submitLabel="Create"
        exportFormat="object"
        useDirtyWarning={false}
        submitAll
        showHelp={false}
      />
    </div>
  );
};

export default CreateSimilarQuote;
